<template>
  <div :class="isActive && isAnimate ? 'pl-count pl-count--light' : 'pl-count'">
    {{ formattedHours + ':' + formattedMinutes + ':' + formattedSeconds }}
  </div>
</template>
<script>
export default {
  name: 'Counter',

  data: () => ({
    seconds: 0,
    minutes: 0,
    hours: 0,
    time: '',
    counter: null,
  }),

  methods: {
    addHours() {
      this.hours++
      if (this.hours == 60) {
        this.hours = 0
      }
      return this.hours
    },
    addMinutes() {
      this.minutes++
      if (this.minutes == 60) {
        this.minutes = 0
        this.addHours()
      }
      return this.minutes
    },
    addSeconds() {
      this.seconds++
      if (this.seconds == 60) {
        this.seconds = 0
        this.addMinutes()
      }
      return this.seconds
    },

    startCount() {
      const self = this
      this.counter = setInterval(function () {
        self.addSeconds()
      }, 1000)
    },
    stopCount() {
      clearInterval(this.counter)
      const self = this
      setTimeout(function () {
        self.seconds = 0
        self.minutes = 0
        self.hours = 0
      }, 3000)
    },
  },

  computed: {
    formattedSeconds() {
      if (this.seconds < 10) return `0${this.seconds}`
      return this.seconds
    },
    formattedMinutes() {
      if (this.minutes < 10) return `0${this.minutes}`
      return this.minutes
    },
    formattedHours() {
      if (this.hours < 10) return `0${this.hours}`
      return this.hours
    },
  },

  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    isAnimate: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    isActive(val) {
      if (val) {
        this.startCount()
      } else {
        this.stopCount()
      }
    },
  },
}
</script>
